'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _targetdrgs = require('./targetdrgs.component');

var _targetdrgs2 = _interopRequireDefault(_targetdrgs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var targetdrgsModule = _angular2.default.module('targetdrgs', [_angularUiRouter2.default]).component('targetdrgs', _targetdrgs2.default);

exports.default = targetdrgsModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/targetdrgs/targetdrgs.js